var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("span", {
      domProps: {
        innerHTML: _vm._s(
          _vm.$t("notification.taskArchived", {
            user: _vm.getActorName,
            task: _vm.$_.get(_vm.activity, "payload.taskTitle"),
          })
        ),
      },
    }),
    _vm.ruleSource
      ? _c("span", [
          _vm._v(" ("),
          _c("em", [_vm._v(_vm._s(_vm.ruleSource))]),
          _vm._v(" aracılığıyla)"),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }